var map = {
	"./Communications/communications.module": [
		"./src/app/pages/students-portal/Communications/communications.module.ts",
		"Communications-communications-module"
	],
	"./_layouts/main/module/main.module": [
		"./src/app/_layouts/main/module/main.module.ts",
		"_layouts-main-module-main-module"
	],
	"./activities/activities.module": [
		"./src/app/pages/communications/activities/activities.module.ts",
		"activities-activities-module"
	],
	"./advisory-works/advisory-works.module": [
		"./src/app/pages/academic/advisory-works/advisory-works.module.ts",
		"default~advisory-works-advisory-works-module~attendance-attendance-module~evaluations-evaluations-mo~2dd8b0e3",
		"common"
	],
	"./attendance/attendance.module": [
		"./src/app/pages/academic/attendance/attendance.module.ts",
		"default~advisory-works-advisory-works-module~attendance-attendance-module~evaluations-evaluations-mo~2dd8b0e3",
		"common",
		"attendance-attendance-module"
	],
	"./calender/calender.module": [
		"./src/app/pages/communications/calender/calender.module.ts",
		"default~calender-calender-module~src-app-pages-users-users-module",
		"common",
		"calender-calender-module"
	],
	"./circulars/circulars.module": [
		"./src/app/pages/communications/circulars/circulars.module.ts",
		"circulars-circulars-module"
	],
	"./emails/emails.module": [
		"./src/app/pages/communications/emails/emails.module.ts",
		"emails-emails-module"
	],
	"./evaluations/evaluations.module": [
		"./src/app/pages/academic/evaluations/evaluations.module.ts",
		"default~advisory-works-advisory-works-module~attendance-attendance-module~evaluations-evaluations-mo~2dd8b0e3",
		"common",
		"evaluations-evaluations-module"
	],
	"./events/events.module": [
		"./src/app/pages/communications/events/events.module.ts",
		"events-events-module"
	],
	"./gallery/gallery.module": [
		"./src/app/pages/communications/gallery/gallery.module.ts",
		"gallery-gallery-module"
	],
	"./grading-assessments/grading-assessments.module": [
		"./src/app/pages/academic/grading-assessments/grading-assessments.module.ts",
		"grading-assessments-grading-assessments-module"
	],
	"./health-records/health-records.module": [
		"./src/app/pages/academic/health-records/health-records.module.ts",
		"health-records-health-records-module"
	],
	"./learning-path/learning-path.module": [
		"./src/app/pages/academic/learning-path/learning-path.module.ts",
		"default~learning-path-learning-path-module~plans-plans-module",
		"common",
		"learning-path-learning-path-module"
	],
	"./news/news.module": [
		"./src/app/pages/communications/news/news.module.ts",
		"news-news-module"
	],
	"./notes/notes.module": [
		"./src/app/pages/academic/notes/notes.module.ts",
		"default~advisory-works-advisory-works-module~attendance-attendance-module~evaluations-evaluations-mo~2dd8b0e3",
		"common",
		"notes-notes-module"
	],
	"./notice/notice.module": [
		"./src/app/pages/communications/notice/notice.module.ts",
		"common",
		"notice-notice-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/students-portal/students.module": [
		"./src/app/pages/students-portal/students.module.ts",
		"pages-students-portal-students-module"
	],
	"./plans/plans.module": [
		"./src/app/pages/academic/plans/plans.module.ts",
		"default~learning-path-learning-path-module~plans-plans-module",
		"common",
		"plans-plans-module"
	],
	"./questions-bank/questions-bank.module": [
		"./src/app/pages/academic/questions-bank/questions-bank.module.ts",
		"questions-bank-questions-bank-module"
	],
	"./reports-cards/reports-cards.module": [
		"./src/app/pages/academic/reports-cards/reports-cards.module.ts",
		"reports-cards-reports-cards-module"
	],
	"./sms/sms.module": [
		"./src/app/pages/communications/sms/sms.module.ts",
		"sms-sms-module"
	],
	"./social-learning/social-learning.module": [
		"./src/app/pages/communications/social-learning/social-learning.module.ts",
		"social-learning-social-learning-module"
	],
	"./statistics/statistics.module": [
		"./src/app/pages/academic/grading-assessments/statistics/statistics.module.ts",
		"statistics-statistics-module"
	],
	"./timetable/timetable.module": [
		"./src/app/pages/academic/timetable/timetable.module.ts",
		"timetable-timetable-module"
	],
	"./usersTabs/users-tabs.module": [
		"./src/app/pages/users/usersTabs/users-tabs.module.ts",
		"usersTabs-users-tabs-module"
	],
	"./votes/votes.module": [
		"./src/app/pages/managerial/votes/votes.module.ts",
		"votes-votes-module"
	],
	"src/app/pages/academic/academic.module": [
		"./src/app/pages/academic/academic.module.ts",
		"src-app-pages-academic-academic-module"
	],
	"src/app/pages/classes/classes.module": [
		"./src/app/pages/classes/classes.module.ts",
		"src-app-pages-classes-classes-module"
	],
	"src/app/pages/communications/communications.module": [
		"./src/app/pages/communications/communications.module.ts",
		"src-app-pages-communications-communications-module"
	],
	"src/app/pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"common",
		"src-app-pages-dashboard-dashboard-module"
	],
	"src/app/pages/managerial/managerial.module": [
		"./src/app/pages/managerial/managerial.module.ts",
		"src-app-pages-managerial-managerial-module"
	],
	"src/app/pages/nslia/nslia.module": [
		"./src/app/pages/nslia/nslia.module.ts",
		"src-app-pages-nslia-nslia-module"
	],
	"src/app/pages/settings/system-settings.module": [
		"./src/app/pages/settings/system-settings.module.ts",
		"src-app-pages-settings-system-settings-module"
	],
	"src/app/pages/users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"default~calender-calender-module~src-app-pages-users-users-module",
		"common",
		"src-app-pages-users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;